import { render, staticRenderFns } from "./GlobalSidebar.vue?vue&type=template&id=1c816de2"
import script from "./GlobalSidebar.vue?vue&type=script&lang=ts"
export * from "./GlobalSidebar.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSidebar.vue?vue&type=style&index=0&id=1c816de2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports